import { BookingRemarkActionTypes } from "./types"
import type { BookingRemarkState, BookingRemarkAction } from "./types"
import { commonHelpers } from "@/utils/helpers"

export const initialState: BookingRemarkState = {
  bookingRemark: null,
  bookingRemarkError: "",
  bookingRemarkLoading: false,
}

const reducer = (state = initialState, action: BookingRemarkAction) => {
  switch (action.type) {
    case BookingRemarkActionTypes.FETCH_REQUESTED: {
      const { scope } = action.payload

      return {
        ...state,
        [`${scope}Loading`]: true,
        [`${scope}Error`]: "",
      }
    }
    case BookingRemarkActionTypes.FETCH_SUCCEEDED: {
      const { scope, data, count } = action.payload

      return {
        ...state,
        [scope]: data,
        [`${scope}Loading`]: false,
        [`${scope}Error`]: "",
        ...(commonHelpers.isNumber(count)
          ? {
              [`${scope}Count`]: count,
            }
          : {}),
      }
    }

    case BookingRemarkActionTypes.FETCH_FAILED: {
      const { scope, error } = action.payload

      return {
        ...state,
        [`${scope}Error`]: error,
      }
    }
    default: {
      return state
    }
  }
}

export default reducer
